import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { DocumentContext } from "~context/DocumentContext";
import { useInterval } from "~utils/hooks";
import { getRandomIntByRange } from "~utils/helpers";

const Typer = ({ className, color, text }) => {
  const { windowWidth, windowHeight, device } = useContext(DocumentContext);
  const sizeRef = useRef();
  const [cursorInvisible, setCursorInvisible] = useState(false);
  const [lastText, setLastText] = useState(text);
  const [renderedText, setRenderedText] = useState(``);
  const [renderedHeight, setRenderedHeight] = useState(0);
  const [typedIndex, setTypedIndex] = useState(0);

  //

  useInterval(() => {
    if (text !== lastText) {
      return;
    }

    setCursorInvisible(!cursorInvisible);
  }, 500);

  useEffect(() => {
    if (!sizeRef.current) {
      return;
    }

    setRenderedHeight(sizeRef.current.getBoundingClientRect().height);
  }, [windowWidth, windowHeight, text]);

  useEffect(() => {
    if (text !== lastText) {
      setLastText(text);
      setRenderedText(``);
      setTypedIndex(0);
    }
  }, [text]);

  useEffect(() => {
    if (!window) {
      return () => {};
    }

    if (typedIndex === text.length) {
      if (renderedText !== text) {
        setRenderedText(text);
      }

      return () => {};
    }

    //

    setRenderedText(
      `${renderedText}${text.substring(typedIndex, typedIndex + 1)}`
    );

    const typingTimeout = setTimeout(() => {
      setTypedIndex(typedIndex + 1);
    }, getRandomIntByRange(0, 40));

    return () => {
      clearTimeout(typingTimeout);
    };
  }, [typedIndex]);

  //

  // return <></>;

  return (
    <div className={`${className} relative`}>
      <span
        className={`typer text-${color} ${device === `mobile` &&
          `whitespace-pre-wrap`}`}
        style={{ height: `${renderedHeight}px` }}
      >
        {renderedText}
      </span>

      <span
        className={`${
          cursorInvisible ? `opacity-0` : ``
        } typer__cursor text-${color}`}
      >
        |
      </span>

      <span
        ref={sizeRef}
        className="typer w-full block absolute top-0 left-0 opacity-0 pointer-events-none"
      >
        {text}
      </span>
    </div>
  );
};

Typer.defaultProps = {
  className: ``,
  color: `navy`
};

Typer.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string.isRequired
};

export default Typer;
